import type { ResponseModel } from "@/Models/ResponseModel";
import type { WorkspaceProfile } from "@/Models/WorkspaceProfile";
import { Http } from "@/Request";
import type { Locale } from "@/libs/localization/i18n";

export class AccountService {
  public static getProfile = (
    locale: Locale,
  ): Promise<ResponseModel<WorkspaceProfile | null>> => {
    return new Promise((resolve, reject) => {
      Http.get<ResponseModel<WorkspaceProfile | null>>(`/${locale}/account/profile`)
        .then((response) => resolve(response.data))
        .catch(reject);
    });
  };
}
